// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js

import $ from 'jquery';
window.jQuery = $;
import $r from 'js/core_pre_webpack/routes';

var i = window.i;
var fxs = window.fxs;
// modified with global simulating transforms: pre, post
// MAGIC_DESPROCKET_END
(function(window) {
    // Return if we have already run this.
    if(window.scribd) { return; }

    // Utility //

    var isIE  = (navigator.appVersion.indexOf("MSIE") != -1) ? true : false;
    var isWin = (navigator.appVersion.toLowerCase().indexOf("win") != -1) ? true : false;
    var isOpera = (navigator.userAgent.indexOf("Opera") != -1) ? true : false;

    var getRandomInt = function(min, max)  {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };

    var addScriptTag = function(src, body, id) {
        var head = document.getElementsByTagName('head')[0];
        var tag = document.createElement('script');
        if (src) {
            tag.src = src;
        }
        if (body) {
            tag.text = body;
        }
        if (id) {
            tag.id = id;
        }
        head.appendChild(tag);
        return tag;
    };

    var addCssLinkTag = function(href) {
        var head = document.getElementsByTagName('head')[0];
        var tag = document.createElement('link');
        tag.rel = 'stylesheet';
        tag.type = 'text/css';
        if (href) {
            tag.href = href;
        }
        head.appendChild(tag);
        return tag;
    };

    var addStyleTag = function(body) {
        var head = document.getElementsByTagName('head')[0];
        var tag = document.createElement('style');
        if (body) {
            tag.text = body;
        }
        head.appendChild(tag);
        return tag;
    };

    // Document class

    function Document(options) {
      this.params = {};

      this.params.domain = 'www.scribd.com'; // default domain if none set
      this.params.zoom = 1; // default zoom

      if (options.hasOwnProperty('upload_from_url')) {
        this.params.upload_from_url = options.upload_from_url;
      }
      if (options.hasOwnProperty('url')) {
        this.params.url = options.url;
      }
      if (options.hasOwnProperty('publisher_id')) {
        this.params.publisher_id = options.publisher_id;
      }

      if (options.hasOwnProperty('attachment_id')) {
        this.params.attachment_id = options.attachment_id;
      }

      if (options.hasOwnProperty('scroll_parent')) {
        this.params.scroll_parent = options.scroll_parent;
      }

      this.__callQueue = []; // stores premature method calls for later replay, technically a stack (FILO)
      this.__listenerLookup = {}; // lookup[ eventType:String ] -> [ callback1:Function, callback2:Function ... ]
    }

    Document.prototype = {

        /* ---------------

        Private Methods

        ------------------ */

        // Undo the effects of calling .write() or .seamless().
        __remove: function() {
            var el;
            el = this.getElement();
            if (el) { el.parentNode.removeChild(el); }
            el = document.getElementById('scribd_pager');
            if (el) { el.parentNode.removeChild(el); }
        },

        // method that will fire off an event, whatever browser is used
        __fireEvent: function( eventType ) {
          var el = this.getElement();
          if (el.addEventListener){
            var ev = document.createEvent('HTMLEvents');
            ev.initEvent(eventType, true, false);
            el.dispatchEvent(ev);
          } else if (el.attachEvent){
            this.__handleEvent( eventType );
          }
        },

        // set up event handlers for the embeds
        __setupEvents: function() {
            var __this = this;

            // Event router for IE (which doesn't properly support custom events)
            window[ "_scribd_event_handler_" + this.params.embed_name ] = function(eventType){ __this.__handleEvent(eventType); };

            //
            // setupJsApi -- attach event listeners
            //
            var onSetupJsApi = function(e) {
                e = e || {};      // In the case of IE, there will be no Event so we return an empty object
                var target = null;
                var el = __this.getElement();
                if (e.srcElement && e.srcElement.getAttribute('id') === __this.params.embed_name) {
                   target = e.srcElement;
                } else if ( el && el.getAttribute('id') === __this.params.embed_name ) {
                   target = el;
                }
                if (target) {
                    if (!__this.api) {
                      __this.api = target;
                    }
                    // Grab the next call on the queue, check to see if it's actionable, if not push onto a stack which will replace __callQueue
                    var i, method, callParams, rejectedCalls = [];

                    for (i = 0; i < __this.__callQueue.length; i++) {
                      callParams = __this.__callQueue[i];
                      if (callParams[0] == "addEventListener") {  // Execute all listener calls
                        method = callParams.shift();
                        __this[method].apply( __this, callParams );
                      } else {
                        rejectedCalls.push( callParams ); // Send back to __callQueue
                      }
                    }
                    __this.__callQueue = rejectedCalls; // end callQueue
                }
            };

            // This should be deprecated, but is here for backwards compatibility (and the iPaper reader only sends this event). Forward to docReady.
            var oniPaperReady = function(e) {
                __this.__fireEvent('docReady');
            };

            //
            // iDocReady -- pump call queue
            //

            var onDocReady = function(e) {
                e = e || {};        // In the case of IE, there will be no Event so we return an empty object
                var target = e.srcElement || __this.getElement();

                if (target.getAttribute('id') == __this.params.embed_name) {

                    if (__this.onReady){
                        __this.onReady();
                    }

                    // Grab the next call on the queue, check to see if it's actionable, if not push onto a stack which will replace __callQueue (rejectedCalls)
                    var i, method, callParams, rejectedCalls = [];
                    for (i=0; i<__this.__callQueue.length; i++) {
                      callParams = __this.__callQueue.pop();
                      if (callParams[0] != "addEventListener") {  // Execute all non-listener calls
                        method = callParams.shift();
                        if (typeof method != "function") {
                            alert(typeof method);
                        }
                        __this[ method ].apply( __this, callParams );
                      } else {
                        rejectedCalls.push( callParams ); // Send back to __callQueue
                      }
                    }
                    __this.__callQueue = rejectedCalls;
                }
            };

            if (window.addEventListener){
                window.addEventListener('iPaperReady', oniPaperReady, true);
                window.addEventListener('docReady', onDocReady, true);
                window.addEventListener('setupJsApi', onSetupJsApi, true);
            } else {
                // No DOM 2 Support
                __this.__addRoutedListener('iPaperReady', oniPaperReady);
                __this.__addRoutedListener('docReady', onDocReady);
                __this.__addRoutedListener('setupJsApi', onSetupJsApi);
            }
        },

        /* ---------------

        Note: Routed events are those which get routed through a globally defined method: window._scribd_event_handler_embedName()
        We define this method to allow message passing between iPaper and this particular scribd.Document instance. Only used
        for browsers which don't adhere to the DOM 2 event specification (IE).

        Workflow:
            1) Assign window._scribd_event_handler_embedName = this.__handleEvent, in this.write()
            2) Add any event listeners to this.__listenerLookup
            3) iPaper calls window._scribd_event_handler_embedName to trigger events, which get routed back through to this.__handleEvent
            4) Iterate through __listenerLookup, firing the appropriate callbacks

        ----------------- */

        __handleEvent: function( eventType ){
            var listeners = this.__listenerLookup[eventType] || [];
            for (var i=0; i<listeners.length; i++)
            {
                listeners[i]();
            }
        },

        __addRoutedListener: function( eventType, callback ){
            if ( this.__listenerExists(eventType, callback) )
                return;

            if (this.__listenerLookup[ eventType ]){
                this.__listenerLookup[ eventType ].push(callback);
            } else {
                this.__listenerLookup[ eventType ] = new Array( callback );
            }
        },

        __removeRoutedListener: function( eventType, callback ){
            var listeners = this.__listenerLookup[ eventType ];
            for (var i=0; i<listeners.length; i++ ){
                if( listeners[i] == callback ){
                    listeners.splice(i, 1);
                }
            }
        },

        __listenerExists: function( eventType, callback ){
            var listeners = this.__listenerLookup[ eventType ] || [];
            for ( var i=0; i<listeners.length; i++ ){
                if (listeners[i] == callback) return true;
            }
            return false;
        },

        // Build a url going to the currently set domain, and using correct
        // http vs https protocol.
        __buildUrl: function(url) {
          return ('https:' == document.location.protocol ? 'https://' : 'http://') +
              this.params.domain + url;
        },

        // jsonp -- to fetch data from the embeds controller and determine whether to write flash or html5

        __jsonp: function(url, callback, callbackName){
          if (typeof(callbackName) === 'undefined') {
              callbackName = 'scribd_jsonp' + getRandomInt(0, 10000000);
          }

          window[callbackName] = function(data){
            callback(data);
            window[callbackName] = undefined;
          };
          // When you want to do a jsonp call, you have to add a stub url param
          // of "callback=CALLBACK_NAME". This must come as the first url param, i.e.
          // immediately after the first question mark.
          //TODO: This is an awful, brittle, kludge and should be changed.
          var newurl = url.replace('CALLBACK_NAME', callbackName);
          return addScriptTag(newurl);
        },

        __uploadFromUrl: function() {
          url = this.__buildUrl('/upload/auto?callback=CALLBACK_NAME&urls=' + encodeURIComponent(this.params.url) + '&from_jsapi=true');

          if (!this.params['public']) {
             url += '&private=1';
          }
          if (this.params.publisher_id) {
            url += '&scribd_publisher_id=' + this.params.publisher_id;
          }
          if (this.params.my_user_id) {
            url += '&my_user_id=' + this.params.my_user_id;
          }
          if (this.params.extension) {
            url += '&extension=' + encodeURIComponent(this.params.extension);
          }
          if (this.params.title) {
            url += '&title=' + encodeURIComponent(this.params.title);
          }
          var __this = this;
          this.__jsonp(url, function(result){__this.__afterCreateDoc(result);});
        },

        // jsonp callback after a slurp for getDocFromUrl
        __afterCreateDoc: function(result) {
          if (result.success) {
            // reset the following params because if the 4gen doc isn't ready yet, we don't want the flash reader to re-slurp.
            this.params.upload_from_url = undefined;
            this.params.url = undefined;
            this.params.publisher_id = undefined;
            this.__getEmbedFormat();
          } else {
            this.getElement().innerHTML = '<span style="color:red;">Error: ' + result.message + '</span>';
          }
        },

        __getDefaultFormat: function() {
          this.params.default_embed_format = 'html5';
          return this.params.default_embed_format;
        },

        // Set the "embed_url" param

        //TODO: this should be refactored to remove dependencies on the
        //current state of this.params, and use arguments and a return
        //value instead.
        __calculateEmbedUrl: function() {
          const embed_url = $r.api_v0_document_viewer_show_build_vu_embed_url({
            id: this.params.attachment_id,
            subdomain_param: 'api',
            callback: 'CALLBACK_NAME', // dynamically replaced
          });

          this.params.embed_url = embed_url;
          return embed_url;
        },

        /* ---------------
            Public Methods
        ---------------- */

        seamless: function(id) {
            var __this = this;

            // Load up the embed content by jsonp.
            __this.params.embed_name = id;
            var el = document.getElementById(id);

            var jsonp_seamless_callback = function(data) {
                // Record the id of the enclosing div for 4gen.js to use later.
                scribd.embed_div_id = 'scribd_embedded_doc';

                // 4gen.js needs a stylesheet tag to hook into.
                addStyleTag('');

                // Load the contents into the wrapper div.
                el.innerHTML = '<div id="scribd_embedded_doc">' + data.contents + '</div>';

                // The only thing we need from the header is the javascript and css tags.
                // Depending on the browser, we can't just insert these into
                // the DOM and expect them to load. As a workaround, we will
                // parse out all of the script and link tags with regexes, and
                // put them in the document head manually.

                // We will search through the source for script and link tags,
                // so we need to manually handle commented-out sections.
                var source = data.header + data.contents;
                // Handle IE conditional comments.
                if (isIE) {
                    source = source.replace(/<!--\[if !IE\]><!-->[\s\S]*?<!--<!\[endif\]-->/gim, '');
                    source = source.replace(/<!--\[if IE\]>/, '');
                    source = source.replace(/<!\[endif\]-->/, '');
                }
                source = source.replace(/<!--[\s\S]*?-->/gim, '');

                var match, src_match, tag_string, href, body, src;

                // Load stylesheets.
                var link_re = /<link[^>]*href=['"](.*?)['"][^>]*>/gim;

                while (true) {
                    // Exec-ing multiple times on the source because we passed the g (global) flag.
                    match = link_re.exec(source);
                    if (match === null) { break; }
                    href = match[1];
                    addCssLinkTag(href);
                }


                // Load scripts.
                var script_re = /<script[^>]*>([\s\S]*?)<\/script>/gim;
                var src_re = /src=['"](.*?)['"]/;

                var deferred_scripts = [];
                while (true) {
                    // Exec-ing multiple times on the source because we passed the g (global) flag.
                    match = script_re.exec(source);
                    if (match === null) { break; }

                    // Using regex groups, find the src attribute and script body.
                    tag_string = match[0];
                    body = match[1];
                    src_match = src_re.exec(match[0]);
                    if (src_match === null) {
                        src = null;
                    } else {
                        src = src_match[1];
                    }
                    // Load include-style scripts now, and script bodies later.
                    if (src) {
                        addScriptTag(src, body);
                    } else {
                        deferred_scripts.push(body);
                    }
                }

                // Wait for the document manager class to exist before continuing.
                waitForDocumentManager();
                function waitForDocumentManager() {
                    if (typeof(DocumentManager) === 'undefined') {
                        setTimeout(waitForDocumentManager, 100);
                    } else {
                        after();
                    }
                }
                function after() {
                    // TODO(helen): remove this when scribd gets back to us

                    // this is a slightly modified version of
                    // ScrollViewManager.prototype._gotoPage from scribd's 4gen.js.
                    // the original autoscrolls to the top of the scribd document --
                    // this is a hacky attempt to stop that from happening.
                    var useHacks = false;
                    useHacks = true;
                    var isSingleWork = window.$controller_name === "single_work";
                    var isCV = window.$controller_name === "curriculum_vitaes";
                    
                    // set the scrollParent to the container that in "scrolly"
                    // to override the default, which is to handle scrolls at
                    // the viewport level
                    if (__this.params.scroll_parent) {
                      window.DocumentManager.scrollParent = __this.params.scroll_parent;
                    }

                    if (useHacks || isSingleWork || isCV ) {
                        window.DocumentManager.ScrollViewManager.prototype._gotoPage = function(pageId, options) {
                            options = options || {}

                            if (!this.pages.hasOwnProperty(pageId)) {
                              return
                            }

                            var page = this.documentManager.pages[pageId]
                            this.documentManager.setIsScrolling(true)

                            var scrollContainer = this.documentManager.viewportManager.container
                            page._updateBoundingRect()

                            // hack is here -- took out code to autoscroll if scrollContainer == window
                            if (scrollContainer !== window) {
                              scrollContainer.scrollTop = page.boundingRect.top - (options.offset || 0)
                            }

                            this.documentManager.setIsScrolling(false)

                            if (!this.documentManager.isScrolling) {
                              this.documentManager.visiblePagesChanged()
                            }

                            return page.pageNum
                        };
                    }
                    // end hackiness

                    // Run all the deferred script tags.
                    for (var i = 0; i < deferred_scripts.length; i++) {
                        // TODO(jpettit): More scribd hackiness - the below script fails because _currentViewManager isn't set yet.
                        // Might need to update this script, currently creating one error per SWP load in production.
                        if (deferred_scripts[i] === 'docManager._currentViewManager.shouldRestorePosition = false') {
                            continue;
                        }
                        addScriptTag(null, deferred_scripts[i]);
                    }

                    // Remember the docManager instance that was just been created.
                    __this.docManager = window.docManager;

                    // We have to setup events before we setup the api, so that
                    // the api can fire off the event for setupJsApi. This is
                    // then caught by an event handler that was set in
                    // setupEvents, which then flushes the callQueue.
                    __this.__setupEvents();
                    __this.__setupApiForHtml5();

                    // Get the metadata for the document, but do not write an
                    // iframe to the page, as in the .write method.

                    // last thing to do is trigger the docReady event
                    __this.__fireEvent('docReady');
                }
            };
            var embed_url = __this.__calculateEmbedUrl();

            __this.__jsonp(
              embed_url,
              jsonp_seamless_callback,
              'scribd_seamless_callback_'
            );
        },

        write: function(id, replace) {

          // default to false
          if (replace === undefined) {
             replace = false;
          }

          this.params.replace = replace;

          // if we are replacing, then we don't need to generate a unique name for the element.
          if (replace) {
            this.params.embed_name = id;
          } else {
            this.params.write_element_id = id;
          }
          // unique identifier for this doc
          if (this.params.embed_name === undefined) {
             var name = 'scribd_' + Math.round(Math.random() * 9e9);
             this.params.embed_name = name;
          }
          // if we have to upload the doc first, go ahead and do that before we add the embed *IF* we default to html5
          if (this.params.upload_from_url && this.__getDefaultFormat() === 'html5') {
            this.__uploadFromUrl(); // if default format is flash we don't want to do this!!!
          } else {
            this.__getEmbedFormat();
          }
        },

        addParam: function(name, value) {
           this.params[name] = value;
        },

        addEventListener: function( eventType, callback, optBubble ){
            if (this.api){
                if (window.addEventListener){
                    if (this.api.isHtml5) {
                      var el = this.getElement();
                      el.addEventListener( eventType, callback, false );
                    } else {
                      this.api.parentNode.addEventListener( eventType, callback, false );
                    }
                } else {
                    this.__addRoutedListener( eventType, callback );
                }
            } else {
                this.__callQueue.push(["addEventListener", eventType, callback, false]);
            }
        },

        removeEventListener: function( eventType, callback ){
            if (this.api){
                if (window.addEventListener){
                    if (this.api.isHtml5) {
                      var el = this.getElement();
                      el.removeEventListener( eventType, callback, false );
                    } else {
                      this.api.removeEventListener( eventType, callback, false );
                    }
                } else {
                    this.__removeRoutedListener( eventType, callback );
                }
            } else {
                this.__callQueue.push(["removeEventListener", eventType, callback]);
            }
        },

        getFormat: function() {
           return this.params.current_format;
        },

        // this isn't in the api doc, but it's useful.
        getElement: function () {
            var el = document.getElementById(this.params.embed_name);
            if (!el) {
              el = document.getElementById(this.params.write_element_id);
            }
            return el;
        },

        // also not in the api doc. what is this for?
        grantAccess: function(user_identifier, secure_session_id, signature) {
            this.params.user_identifier = user_identifier;
            this.params.secure_session_id = secure_session_id;
            this.params.signature = signature;
        },

        // api
        /*
          NOTE:

          There's an open question about how we can implement the equivalent iPaper api object.
          Since the iframe is on a different domain, we run into non-trivial cross domain issues.
          We can get around that by using various techniques. A common one is to fiddle with the url hash
          param of the iframe, and the javascript in content.js can detect the hash changes.

          For example, api.setZoom could apply the following hash:

          #zoom=2

          And content.js would detect it and zoom to 2.

          There is also the problem of reading data from the embed, like with api.getZoom.
          This could also be solved via passing info through the hash, and the javascript
          on the embeder's page could detect the change.

          However, there are performance issues with this, as polling is the only method
          that works consistently across browsers, and having multiple embeds on a page
          polling for hash change events is not desirable.

        */
        __setupApiForHtml5: function() {
           var __this = this;
           this.api = {
              isHtml5: true,
              getPageCount: function() {
                return __this.data.pages;
              },
              getPage: function() {
                 var page = __this.params.page;
                 if (page === undefined) { page = 1; }
                 return page;
              },
              setPage: function( pageNumber ) {
                 if (pageNumber > __this.data.pages) {
                   pageNumber = __this.data.pages;
                 } else if (pageNumber < 1) {
                   pageNumber = 1;
                 }
                 if (typeof(__this.docManager) !== 'undefined') {
                     __this.params.page = pageNumber;
                     __this.docManager.gotoPage(parseInt(pageNumber, 10));
                 } else {
                     __this._socket.postMessage("page:" + pageNumber);
                 }
              },
              loadDocument: function() {
                 __this.write(__this.params.write_element_id, __this.params.replace);
              },
              getViewMode: function() {
                 var mode = __this.params.mode;
                 if (mode === undefined) { mode = __this.data.view_mode; } // get doc default view mode if no default is set through API
                 return mode;
              },
              getTitle: function() {
                 return __this.data.title;
              },
              getAuthorId: function() {
                 return __this.data.author_id;
              },
              getAuthorName: function() {
                 return __this.data.author_name;
              },
              getZoom: function() {
                 return __this.params.zoom;
              },
              setZoom: function( zoomFactor ) {
                  if (typeof(__this.docManager) !== 'undefined') {
                      __this.params.zoom = zoomFactor;
                      __this.docManager._currentViewManager.resetZoom();
                      __this.docManager._currentViewManager.zoom(zoomFactor);
                  } else {
                      __this._socket.postMessage('zoom:' + zoomFactor);
                  }
              },

              // Functions that are NOT SUPPORTED for HTML5

              // doesn't really work for flash anyway
              loadDocumentFromUrl: function( url, publisher_id ) {
                 // stub
              },
              // Currently, getEmbedCode DOESN'T work for Flash, so we won't be supporting this.
              getEmbedCode: function() {
                 // stub
              },
              getVerticalScroll: function() {
                 // stub
              },
              setVerticalScroll: function( scrollPosition ) {
                 // stub
              },
              getHorizontalScroll: function() {
                 // stub
              },
              setHorizontalScroll: function( scrollPosition ) {
                 // stub
              },
              getFullscreen: function() {
                 // stub
              },
              setFullscreen: function( fullscreen ) {
                 // stub
              }
           };
           this.__fireEvent('setupJsApi');
        }
    };

    //////////////////////////////////////////////////////////////////////////////

    Document.getDoc = function (attachment_id, scroll_parent = null) {
      return new Document({
        attachment_id: attachment_id,
        scroll_parent: scroll_parent,
      });
    };

    Document.getDocFromUrl = function(url, publisher_id) {
        return new Document({ url: url, publisher_id: publisher_id, upload_from_url: true });
    };

    window.scribd = {
        Document: Document,
        _api_version: 2
    };
})(window);

if(window._on_scribd_load !== undefined){
  var i;
  var fxs = window._on_scribd_load;
  window._on_scribd_load = undefined;
  for(i=0;i< fxs.length;i++){
    fxs[i]();
  }
};

export default window.scribd;
// MAGIC_DESPROCKET_START
window.i = i;
window.fxs = fxs;
// MAGIC_DESPROCKET_END
